.feedback-bar {
  border-radius: 0.5rem;
  display: flex;
  font-weight: var(--semibold);
  gap: 0.5rem;
  justify-content: space-between;
  max-height: 0;
  opacity: 0;
  padding: 0 1rem;
  transition: all 0.5s;
}

.feedback-bar--information {
  background-color: var(--color-navy-200);
  border: 1px solid var(--color-navy-600);
}
.feedback-bar--success {
  background-color: var(--color-forest-200);
  border: 1px solid var(--color-forest-600);
}
.feedback-bar--warning {
  background-color: var(--color-orange-200);
  border: 1px solid var(--color-orange-600);
}
.feedback-bar--danger {
  background-color: var(--color-red-200);
  border: 1px solid var(--color-red-600);
}

.feedback-bar--visible {
  max-height: 6.625rem;
  opacity: 1;
  padding: 1rem;
}

.feedback-bar__close-button {
  align-items: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  display: inline-flex;
  height: 1.5rem;
  justify-content: center;
  transition: var(--transition-colors);
  width: 1.5rem;
}

.feedback-bar__close-button:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.feedback-bar--information .feedback-bar__close-button:hover {
  background-color: var(--color-navy-600);
  color: var(--color-uva-white);
  cursor: pointer;
  outline: 0;
}

.feedback-bar--success .feedback-bar__close-button:hover {
  background-color: var(--color-forest-600);
  cursor: pointer;
  outline: 0;
}

.feedback-bar--warning .feedback-bar__close-button:hover {
  background-color: var(--color-orange-600);
  cursor: pointer;
  outline: 0;
}

.feedback-bar--danger .feedback-bar__close-button:hover {
  background-color: var(--color-red-600);
  color: var(--color-uva-white);
  cursor: pointer;
  outline: 0;
}

/* make the clickable area of the overlay close button 42x42px simmilar to a regular button */

.feedback-bar__close-button::after {
  content: " ";
  height: 2.625rem;
  position: absolute;
  width: 2.625rem;
}
